var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-input',{staticClass:"form-input",style:(_vm.styles),attrs:{"id":"id || label","no-error-icon":"","dense":"","label":_vm.label,"type":_vm.type,"input-style":_vm.inputStyle,"value":_vm.value,"disable":_vm.disable,"rules":_vm.rules},on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }